import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/worldnewscentral/mm-client/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/worldnewscentral/mm-client/node_modules/@mui/material/esm/Button/Button.js");
;
import(/* webpackMode: "eager" */ "/var/www/worldnewscentral/mm-client/node_modules/@mui/material/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/worldnewscentral/mm-client/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/worldnewscentral/mm-client/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/worldnewscentral/mm-client/src/components/ClientNewsCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/worldnewscentral/mm-client/src/components/InfiniteScrollNewsLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/worldnewscentral/mm-client/src/components/PaginationLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/worldnewscentral/mm-client/src/components/StructuredData.tsx");
